<template>
  <div id="new-users">
    <BreadCrumb :items="breadcrumbItems" />
    <v-alert
      :class="success ? 'open' : 'close'"
      type="success"
      border="left"
      prominent
      class="absolute absolute--bottom"
    >
      Usuário cadastrado com sucesso!
    </v-alert>

    <v-card
      v-if="loading && parameterID"
      elevation="2"
      class="py-5 px-5 mt-1 text-center"
    >
      Aguarde, buscando dados
      <div class="mt20"></div>
      <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
    </v-card>
    <v-card v-else elevation="2" class="py-5 mt-1">
      <div class="header d-flex justify-space-between pr-5 pb-5">
        <h1>{{ namePage }}</h1>
      </div>

      <v-form @submit.prevent="submit">
        <v-row class="px-9">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="name"
              label="Nome (Obrigatório)"
              required
              aria-autocomplete="off"
              :disabled="onlyView"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="cpf"
              label="CPF (Obrigatório)"
              required
              aria-autocomplete="off"
              v-mask="'###.###.###-##'"
              :disabled="onlyView"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="email"
              label="Email (Obrigatório)"
              type="email"
              required
              aria-autocomplete="off"
              :disabled="onlyView"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="password"
              label="Senha (Obrigatório)"
              type="password"
              required
              aria-autocomplete="off"
              :disabled="onlyView"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="confirmPassword"
              label="Confirmar Senha (Obrigatório)"
              type="password"
              aria-autocomplete="off"
              required
              :disabled="onlyView"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <p class="label-radio-group">Acesso (Obrigatório)</p>
            <v-radio-group v-model="roleId" :disabled="onlyView" row>
              <v-radio
                v-for="role in roles"
                :key="role.id"
                :label="role.name"
                :value="role.id"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12">
            <p class="mt-10-topo">
              <small>
                Sua senha deve conter 6 caracteres, pelo menos um número e
                letras maiúsculas e minúsculas e um caracter especial!
              </small>
            </p>
          </v-col>

          <MessagesError :errors="errors" @closeMessages="errors = []" />

          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              large
              :color="onlyView ? 'info' : 'error'"
              :class="onlyView ? '' : 'mr-5'"
              @click="cancel()"
            >
              {{ onlyView ? "VOLTAR" : "CANCELAR" }}
            </v-btn>
            <v-btn
              v-if="!onlyView"
              large
              color="success"
              @click="submit()"
              :loading="loadingToCreate"
            >
              SALVAR
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import BreadCrumb from "../../../components/BreadCrumb.vue";
import MessagesError from "../../../components/MessagesError.vue";

export default {
  name: "NewUser",
  components: {
    BreadCrumb,
    MessagesError,
  },
  data: () => ({
    errors: [],
    id: "",
    name: "",
    cpf: "",
    isValidCPF: false,
    email: "",
    password: "",
    confirmPassword: "",
    isValidPassword: false,
    roleId: "",
    success: false,
    loading: false,
    loadingToCreate: false,
  }),
  computed: {
    ...mapGetters("UserStore", ["getRoles"]),
    breadcrumbItems() {
      return [
        {
          text: "Início",
          disabled: false,
          to: "/start",
          exact: true,
        },
        {
          text: "Usuários",
          disabled: false,
          to: "/users",
          exact: true,
        },
        {
          text: this.namePage,
          disabled: true,
        },
      ];
    },
    namePage() {
      if (this.parameterID) {
        if (this.onlyView) {
          return "Visualizar usuário";
        } else {
          return "Editar usuário";
        }
      }

      return "Novo usuário";
    },
    roles() {
      return this.getRoles;
    },
    parameterID() {
      return this.$route.params.id;
    },
    onlyView() {
      return this.$route.name === "ViewUser";
    },
  },
  mounted() {
    this.fetchAllRoles();

    if (this.parameterID) {
      this.userEdit();
    }
  },
  methods: {
    ...mapActions("UserStore", [
      "createUser",
      "fetchRoles",
      "fetchUser",
      "editUser",
    ]),
    ...mapMutations("UserStore", ["setRoles"]),
    async submit() {
      this.loadingToCreate = true;
      let params = {
        name: this.name,
        cpf: this.cpf,
        email: this.email,
        password: this.password,
        confirmPassword: this.confirmPassword,
        roleId: this.roleId,
      };

      if (this.parameterID) {
        params.id = this.parameterID;
      }

      try {
        const status = this.parameterID
          ? await this.editUser(params)
          : await this.createUser(params);

        if (status.success) {
          this.success = true;
          setTimeout(() => {
            this.$router.push("/users");
          }, 1000);
        } else {
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingToCreate = false;
      }
    },
    async fetchAllRoles() {
      try {
        const data = await this.fetchRoles();

        this.roleId = data[0].id;
      } catch (err) {
        console.error(err);
      }
    },
    setValidCPF(bool = true) {
      this.isValidCPF = bool;
    },
    setValidPassword(bool = true) {
      this.isValidPassword = bool;
    },
    cancel() {
      this.$router.back();
    },
    async userEdit() {
      this.loading = true;
      try {
        const data = await this.fetchUser(this.parameterID);

        this.name = data.name;
        this.cpf = data.cpf;
        this.email = data.email;
        this.password = data.password;
        this.confirmPassword = data.confirmPassword;
        this.roleId = data.roleId;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#new-users {
  .mt-10-topo {
    position: relative;
    top: -18px;
    margin: 0;
    padding: 0;
  }
}
</style>
